<template>
	<div id="activity-type-create">
		<vx-card class="mb-base" title="Form User">
			<vue-form-generator
				tag="div"
				:schema="schema"
				:model="model"
				:options="formOptions"
				@model-updated="listen"
			></vue-form-generator>
		</vx-card>
		<div class="vx-col w-full">
			<div class="flex flex-end items-start mb-4">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.push('/user/list').catch(() => {})"
				>Batal</vs-button>
				<vs-button class="mr-4 mb-4" icon-pack="feather" @click="onConfirm">Simpan</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import ref from "@/api/ref.js";
import form from "@/api/form.js";
import user from "@/api/user.js";
import tool from "@/tool/form_tool.js";

export default {
	data() {
		return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			}
		};
	},
	methods: {
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: "Anda yakin untuk melanjutkan proses ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

			user.saveUser(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push("/user/list");
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},
		listen(newVal, schema) {},
		async firstLoad() {
			const frm = await form.getFormUser();
			let tmp = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await user.getUser(idx);
				this.model = xmodel.data.data[0];
				tmp.forEach(el => {
					if (el.type == "vspassword") {
					} else {
						if (
							el.fieldName ==
							"username"
						) {
							el.disabled = true;
						}
						this.schema.fields.push(el);
					}
				});
			} else {
				this.schema.fields = tmp;
				this.model = frm.data.data[0].model;
			}
			await this.getRole();
			await this.getGender();
		},
		async getRole() {
			const prov = await user.roleList({perPage:100000});
			tool.copyValuesToDropDown(
				this.schema.fields,
				"roles",
				prov.data.data
			);
		},
		async getGender() {
			const prov = await ref.getGender();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"gender",
				prov.data.data
			);
		}
	},
	created() {
		this.firstLoad();
	}
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
